import type { EventCatalogEntry } from "@repo/vihangam-yog-shared";

import { Disclosure } from "./Disclosure";

/** The catalog's running order for one day, as `agenda` carries it. */
type AgendaRows = NonNullable<EventCatalogEntry["agenda"]>;

/** Phones start with the list folded; wider screens show it open. Read
 *  once at render: a `<details>` is the visitor's to toggle after that. */
function openByDefault(): boolean {
  return window.matchMedia("(min-width: 768px)").matches;
}

/**
 * A day's programme as a compact two-column list: the time in a narrow
 * left column, what happens on the right. Renders nothing when the
 * catalog has no agenda yet, so a day with times still owed shows no
 * empty heading.
 */
export function Agenda({
  rows,
  // The organisers asked for the fold to say what it hides, since on a
  // phone it starts closed and "Programme" alone read as a heading.
  summary = "Programme (click for schedule)",
  className = "",
}: {
  rows: AgendaRows | undefined;
  summary?: string;
  className?: string;
}) {
  if (!rows || rows.length === 0) {
    return null;
  }
  return (
    <Disclosure summary={summary} open={openByDefault()} className={className}>
      <ul
        className="grid grid-cols-[max-content_minmax(0,1fr)] gap-x-4 gap-y-1.5 text-sm"
        data-testid="agenda"
      >
        {rows.map((r) => (
          <li key={`${r.time}-${r.label}`} className="contents">
            <span className="tabular-nums whitespace-nowrap text-ink-soft">
              {r.time}
            </span>
            <span className="text-ink">{r.label}</span>
          </li>
        ))}
      </ul>
    </Disclosure>
  );
}
